(function ($) {
    $(document).ready(function () {
        var three_col_img = $('.three-col-img .img-wrapper img');
    });

    $(document).ready(function () {

        $('body').click(function (e) {
            if(e.target.id == ".three-col-img .filter span")
                return;
            if($(e.target).closest('.three-col-img .filter span').length)
                return;
            $('.three-col-img .filter span').removeClass("open");
            $('.three-col-img .filter span').not(this).siblings('ul').fadeOut(100);

        });

        $('.ua-ie body .three-col-img').addClass("cl-ie");

        $('.ua-mobile .three-col-img').addClass("cl-touch");



        if ($(".three-col-img").length > 0) {
            /* Get dropdown values and append into HTML */
            if ($(".three-col-img #views-exposed-form-blog-block-1").length > 0) {
                // Solution Level
                $(".three-col-img #views-exposed-form-blog-block-1 #edit-term-node-tid-depth-1 option").each(function () {
                    var filterValue = $(this).attr("value");
                    var filterText = $(this).text();
                    if(filterText!=='- Any -') {
                        $(".three-col-img #solution-type ul").append("<li><a target='_blank' href='/blog?"+filterValue+"'>" + filterText + "</a></li>");
                        console.log(filterValue);
                    }

                });
                // Product Level
                $(".three-col-img #views-exposed-form-blog-block-1 #edit-term-node-tid-depth option").each(function () {
                    var filterValue = $(this).attr("value");
                    var filterText = $(this).text();
                    if(filterText!=='- Any -') {
                        $(".three-col-img #product-type ul").append("<li><a target='_blank' href='/blog?"+filterValue+"'>" + filterText + "</a></li>");
                        console.log(filterValue);
                    }
                });

            }
        }

        $('.three-col-img .filter-wrapper ul').fadeOut(100);
        $('.three-col-img .filter span').click(function () {
            $(this).toggleClass("open");
            $(this).siblings('ul').fadeToggle();
            $('.three-col-img .filter span').not(this).removeClass("open");
            $('.three-col-img .filter span').not(this).siblings('ul').fadeOut(100);
        });


        $.fn.imageResponsiveIe = function () {
            return this.each(function () {
                var imgUrl = $(this).find("img").prop("src");
                if (imgUrl) {
                    $(this).find("img").attr("style", "display: none !important");
                    $(this).css("backgroundImage", 'url(' + imgUrl + ')').css({
                        'background-repeat': 'no-repeat',
                        'background-position': 'center',
                        'background-size': 'cover'
                    });
                }
            });
        };

        $('.three-col-img.cl-ie .img-wrapper').imageResponsiveIe();




    });

    //pagination
    $(".three-col-img .pager li a").click(function () {
        $( document ).ajaxStart(function( event, xhr, settings ) {
            if((".three-col-img").length > 0) {
                var winWidth=$(window).width();
                if(winWidth>991) {
                    console.log('width');
                    $('html,body').animate({
                        scrollTop: $(".three-col-img h3").offset().top - 200
                    }, 250);
                    // },1000);
                }else {
                    $('html,body').animate({
                        scrollTop: $(".three-col-img h3").offset().top - 150
                    }, 250);
                }

            }

        });
    });



})(jQuery);

